export default __webpack_public_path__ + "static/media/users.168afb77.svg";